import React from "react";
import Header from "../Comman/Header";
import Footer from "../Comman/Footer";
import Hero from "./Hero";
import Gallery from "./Gallery";
import WhatIsFT from "./WhatIsFT";
import TribeOCryptoFestival from "./TribeOCryptoFestival";
import LandAwaits from "./LandAwaits";
import WhyChooseK from "./WhyChooseK";
import Frequently from "./Frequently";
import Process from "./Process";
import JoinTheTribe from "./JoinTheTribe";
import Demo from "./Demo";
import Video from "./Video";
import BuYEliteNFT from "./BuYEliteNFT";
import BuySuperElite from "./BuySuperElite";
import HowItWorks from "./HowItWorks";
import TribeOCrypto from "./TribeOCrypto";

export default function Index() {
  return (
    <>
      <div class="boxed_wrapper ltr" style={{ overflow: "hidden" }}>
        <Header />
        <div id="smooth-wrapper">
          <div id="smooth-content">
            <main>
              <Hero />
              <Gallery />
              <WhatIsFT />
              <BuYEliteNFT />
              <BuySuperElite />
              <TribeOCryptoFestival />
              <HowItWorks />
              {/* <TribeOCrypto /> */}
              <Frequently />
              <WhyChooseK />
              {/* <Process /> */}
              {/* <LandAwaits /> */}
              {/* <Video /> */}
              {/* <JoinTheTribe /> */}
              {/* <Demo /> */}
            </main>
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
}
